import React from 'react';
import { useParams } from 'react-router-dom';
import ManualCountingPanel from './ManualCountingPanel';
import ScanCountingPanel from './ScanCountingPanel';

/**
 * Punto de entrada de la pantalla de conteo: solo decide, segun el metodo
 * elegido, que panel renderizar. No tiene estado propio para no romper las
 * reglas de hooks si el metodo cambia sin desmontar el componente.
 */
const CountingScreen = () => {
  const { companyId, sessionId, method } = useParams<{
    companyId: string;
    sessionId: string;
    method: string;
  }>();
  const numericCompanyId = Number(companyId);
  const numericSessionId = Number(sessionId);

  if (method === 'scanner' || method === 'camera') {
    return (
      <ScanCountingPanel companyId={numericCompanyId} sessionId={numericSessionId} method={method} />
    );
  }

  return <ManualCountingPanel companyId={numericCompanyId} sessionId={numericSessionId} />;
};

export default CountingScreen;
